var map = {
	"./image0001.jpg": 204,
	"./image001.jpg": 205,
	"./image002.jpg": 206,
	"./image003.jpg": 207,
	"./image004.jpg": 208,
	"./image005.jpg": 209,
	"./image006.jpg": 210,
	"./image007.jpg": 211,
	"./image008.jpg": 212,
	"./image009.jpg": 213,
	"./image010.jpg": 214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 203;